export const inputCls =
  "w-full bg-transparent border border-white/20 px-4 py-3 text-[#E8E2D2] font-mono-accent text-sm focus:border-[#D47738] focus:outline-none transition-colors";

export const EMPTY = {
  name: "",
  style: "",
  description: "",
  abv: 5,
  ibu: 20,
  volume: "33cl",
  price: 0,
  compare_at_price: "",
  image: "",
  stock: 100,
  featured: false,
  images: "",
  condensation_image: "",
  food_pairings: "",
  recipe_story: "",
};

export const EMPTY_DISCOUNT = {
  code: "",
  type: "percent",
  value: 10,
  active: true,
  min_subtotal: 0,
  expires_at: "",
  max_uses: 0,
};

export const ORDER_STATUSES = ["in_preparazione", "spedito", "consegnato", "annullato"];
export const STATUS_LABELS = {
  in_preparazione: "In preparazione",
  spedito: "Spedito",
  consegnato: "Consegnato",
  annullato: "Annullato",
};
export const STATUS_COLORS = {
  in_preparazione: "bg-[#D47738]/20 text-[#D47738] border-[#D47738]/40",
  spedito: "bg-[#5E6C5E]/30 text-[#E8E2D2] border-[#5E6C5E]",
  consegnato: "bg-[#4A6E4A] text-[#E8E2D2] border-[#4A6E4A]",
  annullato: "bg-[#9E3C3C]/30 text-[#9E3C3C] border-[#9E3C3C]/50",
};

export function Field({ label, v, on, type = "text", tid }) {
  return (
    <div>
      <label className="font-mono-accent text-[10px] uppercase tracking-widest text-[#E8E2D2]/50">{label}</label>
      <input
        type={type}
        step="any"
        value={v ?? ""}
        onChange={(e) => on(e.target.value)}
        className={inputCls + " mt-1"}
        data-testid={tid}
      />
    </div>
  );
}
